<template>
  <div v-if="msgPoints" class="pointsMsg q-ma-md">
    <q-card flat class="bg-white">
      <q-card-section horizontal>
        <img width="50" src="/assets/icons/festa-dig.svg" alt=""/> 
        <div class="q-mx-md text-subtitle1">
          {{msgPoints}}
        </div>
      </q-card-section>
      <q-card-actions class="justify-center">
        <q-btn color="primary" class="square" padding="xs xl" label="Dismiss" @click="msgPoints = null" />
      </q-card-actions>
    </q-card>
  </div>
</template>

<script>
import {onUnmounted, ref} from "vue";

export default {
  name: "LastAdded",
  props: ['userId', 'isAnonymous'],
  setup(props, context) {
    const msgPoints = ref(null)
    const connection = new WebSocket(`${process.env.VUE_APP_WS}?uid=${props.userId}`)

    onUnmounted(() => {
      connection.close()
    })
    
    connection.onmessage = (event) => {
      let data = JSON.parse(event.data)
      if (data && data.points) {
        let emitData = {
          id: data.placeId,
          name: data.place.name,
          points: data.points
        }
        context.emit('update-points', emitData)
        
        if (!data.isPerk) msgPoints.value = 'You just earned ' + data.points + ' point(s) from ' + data.place.name + '.'
        else msgPoints.value = 'You just collected a perk at ' + data.place.name + '!'
      }
    }

    connection.onopen = (event) => {
      context.emit('connected', true)
    }

    connection.onclose = (event) => {
      context.emit('connected', false)
    }

    return {msgPoints}
  }
}
</script>

<style scoped>

</style>